import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomeRoundDoor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"home-round-door"} maskId="square-filled-radius-0-stroke-1-IconHomeRoundDoor"><path d="M12 2.9104L3 8.5354V21H9.5V17C9.5 15.6193 10.6193 14.5 12 14.5C13.3807 14.5 14.5 15.6193 14.5 17V21H21V8.5354L12 2.9104Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconHomeRoundDoor;
